<template lang="html">
  <div class="soroban">
    <div v-if="numberList" class="display">
      <SorobanColumn
        v-for="i in 8"
        :digit="+numberList[i-1]"
        :ID="i-1"
        :key="i-1"
        :clickDisabled="clickDisabled"
        :showResult="showResult"
        @fifthbeadClicked="moveFifth"
        @firstbeadClicked="moveFirst"
        @secondbeadClicked="moveSecond"
        @thirdbeadClicked="moveThird"
        @fourthbeadClicked="moveFourth"
      />
    </div>
  </div>
</template>

<script>
import SorobanColumn from './SorobanColumn.vue'

export default {
  props: {
    clickDisabled :{
      type: Boolean,
      default: true,
    },
    showResult :{
      type: Boolean,
      default: true,
    },
  },
  components: {
    SorobanColumn,
  },
  data(){
    return{

    }
  },
  computed:{
    num:{
      get(){
        return this.$store.getters.displayNumber
      },
      set(newValue){
        this.$store.dispatch('setDisplayNumber', newValue)
      }
    },
    numberList(){
      if(this.num<0 || this.num>99999999){
        return "00000000".split("")
      }else{
        let mynumberstring = this.num.toString();
        let zeronumber = 8-mynumberstring.length
        let zeros = ""
        for (var i = 0; i < zeronumber; i++) {
          zeros += "0"
        }
        mynumberstring = zeros + mynumberstring
        return mynumberstring.split("")
      }
    },
  },
  methods:{
    moveFifth(payload){
      if(payload.status){
        this.num = this.num - (5*Math.pow(10,7-payload.id))
      }else{
        this.num = this.num + (5*Math.pow(10,7-payload.id))
      }
    },
    moveFirst(payload){
      if(payload.status){
        this.num = this.num - (1*Math.pow(10,7-payload.id))
      }else{
        this.num = this.num + (1*Math.pow(10,7-payload.id))
      }
    },
    moveSecond(payload){
      if(payload.status){
        this.num = this.num - (1*Math.pow(10,7-payload.id))
      }else{
        this.num = this.num + (1*Math.pow(10,7-payload.id))
      }
    },
    moveThird(payload){
      if(payload.status){
        this.num = this.num - (1*Math.pow(10,7-payload.id))
      }else{
        this.num = this.num + (1*Math.pow(10,7-payload.id))
      }
    },
    moveFourth(payload){
      if(payload.status){
        this.num = this.num - (1*Math.pow(10,7-payload.id))
      }else{
        this.num = this.num + (1*Math.pow(10,7-payload.id))
      }
    },
  },
  watch:{
    num(){
      if(this.num >99999999 || this.num <0){
        this.$store.dispatch('setDisplayNumber', 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .soroban{
    margin-top: 20px;

    .display{
      display: flex;
      justify-content: center;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
      border: 2px solid brown;
      background-color: #CD853F;
      padding: 10px;
    }
  }
</style>
